import React from 'react';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { RouterLink } from '../../../../components/Link';
import { ConfirmedGraphic } from '../../../../design-system';

export const PasswordChanged = () => (
  <Fade in>
    <div>
      <ConfirmedGraphic textAlign="center" svgProps={{ style: { maxWidth: '60%', height: '100%' } }} />
      <Box mt={3} textAlign="center">
        <Typography>Your password has been reset.</Typography>
      </Box>
      <Box mt={2} textAlign="center">
        <RouterLink to="/auth/signin">Go to sign in screen</RouterLink>
      </Box>
    </div>
  </Fade>
);
